const podHomeDetails = [
  {
    id: "GoPodBasic",
    label: "GoPod Basic",
  },
  {
    id: "GopodPro",
    label: "GoPod Pro",
  },
  {
    id: "GoPodPuzzle",
    label: "GoPod Puzzle",
  },
];

export { podHomeDetails };
